import { HelpersUtils } from '@shared/utils';

interface ISearchHighlightProps {
  className?: string;
  searchText?: string;
  children: string;
}

export const SearchHighlight = (props: ISearchHighlightProps) => {
  const prepareChild = (child: string) => {
    const queryTest = HelpersUtils.getSearchQueryTest(props.searchText || '');

    if (props.searchText) return child?.replace(queryTest, (res) => `<mark class="text-[#e32d33]" style="background: none">${res}</mark>`);
    return child;
  };

  return <span dangerouslySetInnerHTML={{ __html: prepareChild(props.children) }} />;
};
